// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Pitcairn from '../_raw/flag/icon_flag_pitcairn.png';

export default () => <img src={Pitcairn} alt="Pitcairn" />;
